<div style=" min-height: 100vh;" class="blue-bg">
  <div class="max-page-width">
    <div class="authBg container-fluid">
      <div class="card-body">
        <div class="row">
          <div class="col-md-5 p-0 text-right login-image">
            <img class="" src='assets/img/login-image.svg' />
          </div>
          <div  class="col-md-7 text-center">
           <login></login>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
